<template>
  <div :class="$style['store-css']" v-if="shop_info != null">
    <div :class="$style['instoreBody']" style="background-color: #ececec">
      <div style="padding: 10px">
        <div :class="$style['insliderStore-store']">
          <VueSlickCarousel
              v-bind="{ arrows: false, dots: true, autoplay: true,rtl: true }"
              v-if="dataBrand != undefined && dataBrand.length !== 0">
            <div
                :class="$style['inimageSliderStore']"
                v-for="item in dataBrand"
                :key="item.index">
              <img
                  role="button" v-ripple @click="GoToBanner(item)"
                  :src="item.banner_poster"
                  :alt="item.banner_brief"/>
            </div>
          </VueSlickCarousel>
        </div>

        <div :class="$style['shop-css']" v-if="shop_info != null">
          <div>
            <h3>{{ shop_info.shop_name }}</h3>
            <h5 :class="$style['shop-css-p']">{{ shop_info.shop_address }}</h5>
            <a v-if="getContactInformation().length > 0" :href="'tel:' + getContactInformation()">تماس با
              فروشگاه</a>
          </div>
          <div :class="$style['shop-css-ch2']">
            <v-btn v-if="shop_info.shop_type == 0" style="background-color: white; color: #7ec352">
              <v-icon class="ml-1">scatter_plot</v-icon>
              خرید اینترنتی
            </v-btn>
            <v-btn v-if="shop_info.shop_type == 1" style="background-color: white; color: #bb0e0e">
              <v-icon class="ml-1">scatter_plot</v-icon>
              خرید حضوری
            </v-btn>
            <v-btn style="background-color: #7ec352; color:white;" role="button" v-ripple @click="Route()">
              <v-icon class="ml-1">explore</v-icon>
              مسیریابی
            </v-btn>
            <v-btn v-if="shop_info.shop_delivery" style="background-color: #2ab0f7; color:white;">
              <v-icon class="ml-1">check</v-icon>
              ارسال با پیک
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div>
      <v-tabs
          v-model="tabs"
          fixed-tabs color="gray" style="font-size: 11px; font-weight: bold">
        <v-tab
            style="font-size: 11px; font-weight: bold"
            v-for="n in items"
            :key="n">
          {{ n }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div :class="$style['mediaSection']" v-for="(cat, index) in AllitemCat" :key="index">
                <div :class="$style['titleMore']">
                  <h5 style="font-size: 15px">{{ cat.category_name }}</h5>
                  <div :class="$style['showMore']">
                    <router-link :to="{name: 'CatProducts',
                    query: {id: cat.category_id, pname: cat.category_name, cname: shop_info !=null ? shop_info.shop_name : 'فروشگاه', shop_id: id}}">
                      <span style="color: #7ec352; font-size: 12px">مشاهده همه</span>
                      <v-icon style="color: #7ec352; font-size: 14px">chevron_left</v-icon>
                    </router-link>
                  </div>
                </div>
                <div :class="$style['product-targets']">
                  <v-col class="d-flex flex-column" style="align-items: center" cols="3"
                         v-for="(item, index) in cat.children"
                         :key="index">
                    <div :class="$style['itemStory']"
                         role="button" v-ripple
                         @click="showStory(item.category_id, item.category_name, shop_info !=null ? shop_info.shop_name : 'فروشگاه')">
                      <img :src="item.category_cover" :alt="item.category_name"/>
                    </div>
                    <div :class="$style['titleName']">
                      <span>{{ item.category_name }}</span>
                    </div>
                  </v-col>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-card-text>
                <ProductList :list="favoriteList" :shop_id="id"></ProductList>
              </v-card-text>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <div :class="$style.flex">
            <v-card flat>
              <v-card-text>
                <p style="width: 100%" v-if="shop_info != null">{{ shop_info.shop_description }}</p>
              </v-card-text>
            </v-card>
            <div style="margin: 15px" v-if="shop_info.shop_contact != null">
              <div :class="$style.flex_horizontal" v-for="(item, index)  in shop_info.shop_contact"
                   :key="index">
                <i style="margin-left: 5px; font-size: 10px; color: #7dc353" class="mdi mdi-circle"></i>
                <span>{{ item.key }}:</span>
                <a :href="(index == 0 ? 'tel:' : '') + item.value" style="margin-right: 15px">{{ item.value }}</a>
              </div>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div v-if="reviews.length > 0" class="d-flex flex-column">
                <div class="d-flex flex-column mt-3" v-for="(item, index) in reviews" :key="index">
                  <div class="d-flex flex-row align-center justify-space-between mr-1 ml-1">
                    <v-rating background-color="#7ec352" color="#7ec352" dense size="16px" v-model="item.comment_rate"
                              readonly></v-rating>
                    <span class="f8" style="color: #6c757d">{{ oracle.formatDate(item.create_at, false) }}</span>
                  </div>
                  <span class="f9 mb-3" style="white-space: pre-wrap;color: #222222">{{ item.comment_text }}</span>
                  <div style="border-bottom: 1px solid #7ec352"></div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div :class="$style['button-basket-css']">
      <div :class="$style['button-basket-sub']">
        <v-btn role="button" v-ripple @click="goBasket">
          <v-icon>shopping_cart</v-icon>
        </v-btn>
        <p v-if="num_basket != null && num_basket != 0">{{ num_basket }}</p>
      </div>
    </div>

  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import ProductList from "@/pages/ProductList";
import oracle from "@/utils/oracle";

export default {
  name: "StoreInfo",
  components: {VueSlickCarousel, ProductList},
  data() {
    return {
      oracle: oracle,
      favoriteList: [],
      reviews: [],
      id: null,
      items: ['دسته بندی ها', 'محبوب من', 'درباره فروشگاه', 'نظرات کاربران'],
      tabs: null,
      num_basket: null,
      shop_info: null,
      AllitemCat: [],
      category: [],
      dataBrand: [],
    };
  },
  methods: {
    getContactInformation() {
      if (this.shop_info != null && this.shop_info.shop_contact != null
          && this.shop_info.shop_contact.length > 0) {
        return this.shop_info.shop_contact[0].value
      }
      return ""
    },
    goBasket() {
      this.$router.push({name: 'Basket'})
    },
    showStory(id, Pname, Catname) {
      this.$router.push({
        name: 'CatProducts',
        query: {id: id, pname: Pname, cname: Catname, shop_id: this.id}
      })
    },
    Route() {
      let link = "https://www.google.com/maps/@" + this.shop_info.shop_latitude + "," + this.shop_info.shop_longitude + ",19z"
      window.open(link, '_blank');
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.num_basket = oracle.getCount()
    oracle.axios(
        "productCategory/getList",
        {"limit_by": 500, "offset_by": 0, "order_by": "priority"},
        (response) => {
          this.AllitemCat = response.data
        }
    );
    oracle.axios(
        "shop/getOne",
        {"shop_id": this.id},
        (response) => {
          this.shop_info = response.data
          this.dataBrand = [{
            "banner_poster": this.shop_info.shop_poster
          }];
        }
    );
    oracle.axios('product/getFavorites', {"limit_by": 500, "offset_by": 0, "order_by": "priority"}
        , (res) => {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].product_quantity = 0
            res.data[i].product_count = 0
          }
          this.favoriteList = res.data;
          oracle.axios(
              "shop/getQuantities",
              {shop_id: this.id},
              (response) => {
                let qtys = response.data;
                for (let i = 0; i < qtys.length; i++) {
                  for (let j = 0; j < this.favoriteList.length; j++) {
                    if (qtys[i].product_id == this.favoriteList[j].product_id) {
                      this.favoriteList[j].product_quantity = parseInt(qtys[i].product_quantity)
                    }
                  }
                }
              }
          );
        })
    oracle.axios("review/getList", {shop_id: this.$route.query.id}, (response) => {
      this.reviews = response.data
    });
  },
};
</script>
<style module>
.store-css .flex_horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.store-css .flex {
  display: flex;
  flex-direction: column;
  justify-items: center;
}

.store-css .titleMore {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}

.store-css .titleMore h5 {
  font-size: 13px;
  font-weight: bold;
}

.store-css .product-targets {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  overflow: auto;
}

.store-css .itemStory {
  width: 70px;
  height: 70px;
  border-radius: 120px;
  overflow: hidden;
}

.store-css .itemStory img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.store-css .titleName {
  text-align: center;
  font-size: 13px;
  margin-top: 10px;
}

.store-css {
  background: #ffffff;
  margin-bottom: 50px !important;
}

.store-css .instoreBody {
}

.store-css .insliderStore-store .slick-dots {
  bottom: -15px !important;
}

.store-css .insliderStore-store .slick-slide {
  height: auto !important;
}

.store-css .insliderStore-store .slick-dots li {
  width: 10px;
}

.store-css .insliderStore-store .slick-dots li.slick-active button:before {
  width: 10px;
  background: #ffdb02 !important;
}

.store-css .insliderStore-store .slick-dots li button {
  position: absolute;
  top: -36px;
}

.store-css .insliderStore-store::before {
  transform: translateZ(-1px) scale(2);
  z-index: -1;
}

.store-css .inimageSliderStore {
  width: 100% !important;
  height: calc(9 / 16 * 100vw);
  border-radius: 10px;
  overflow: hidden;
}

.store-css .inimageSliderStore a {
  display: flex;
}

.store-css .inimageSliderStore img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.store-css .instore-head {
  z-index: 5;
  position: absolute;
  top: 0;
  left: 0;
}

.store-css .shop-css {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.store-css .shop-css-p {
  font-size: 13px;
  font-weight: normal;
  margin-left: 10px;
  color: grey
}

.store-css .shop-css-ch2 {
  display: flex;
  flex-direction: column
}

.store-css .shop-css-ch2 button {
  margin-bottom: 8px;
  border-radius: 20px;
  height: 32px !important;
  font-size: 10px !important;

}

.store-css .button-basket-css {
  text-align: left;
}

.store-css .button-basket-sub button {
  margin-bottom: 17px;
  position: fixed;
  bottom: 0;
  left: 25px;
  border-radius: 50%;
  background-color: #7ec352 !important;
  color: white !important;
  display: block !important;
  height: 54px !important;
  min-width: 54px !important;
}

.store-css .button-basket-sub p {
  background-color: #cc7540;
  position: fixed;
  bottom: 40px;
  left: 60px;
  border-radius: 50%;
  width: 25px;
  text-align: center;
  color: white;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
}
</style>
